module.exports = __webpack_public_path__ + "img/share_qrcode_bg1_1.1ea09a2c.png";